import { render } from "./Confirm.vue?vue&type=template&id=2a6f3a5c"
import script from "./Confirm.vue?vue&type=script&lang=js"
export * from "./Confirm.vue?vue&type=script&lang=js"
script.render = render

export default script